import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';

const ValidationConfirmationModal = ({
  isVisible,
  validationMessage,
  onCancel,
  onProceed,
  title,
  heading,
  dismissText,
  submitText,
  guidanceText,
}) => (
  <Modal
    title={title}
    closeAction={onCancel}
    dismissText={dismissText}
    dismissAction={onCancel}
    submitText={submitText}
    submitAction={onProceed}
    isVisible={isVisible}
    size="md"
  >
    <div className="validation-confirmation-modal">
      <div className="alert alert-warning" role="alert">
        <strong>{heading}</strong>
      </div>
      <p className="mb-3">{validationMessage}</p>
      <p className="text-muted">
        <small>
          {guidanceText}
        </small>
      </p>
    </div>
  </Modal>
);

ValidationConfirmationModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  validationMessage: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  title: PropTypes.string,
  heading: PropTypes.string,
  dismissText: PropTypes.string,
  submitText: PropTypes.string,
  guidanceText: PropTypes.string,
};

ValidationConfirmationModal.defaultProps = {
  validationMessage: 'A validation issue was detected with your current selection.',
  title: 'Validation Warning',
  heading: 'Validation Issue:',
  dismissText: 'Cancel',
  submitText: 'Proceed',
  guidanceText: 'You can proceed with the current selection, but please verify that this is what you intended. To correct the selection, click "Cancel" and adjust your period selections.',
};

export default ValidationConfirmationModal;
